/**
 * 催尾款（接口服务）
 */
import request from "@utils/request";

const RetroactivePaymmentService = {
    /**
     * 记录催款时间
     *
     * @doc http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6429
     */
    updateRetroactiveTime(data) {
        return request({
            url: "/service/mg/balance-payment/update/register-time",
            method: "POST",
            data
        });
    },

};

export default RetroactivePaymmentService;
